import { render } from "./MaterialCheckbox.vue?vue&type=template&id=386df353"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__